import StaticStickitView from '../static_stickit_view';

export default StaticStickitView.extend({
  bindings: {
    '.js-redo-search-checkbox-input': 'redoSearchWhenMapMoves',
  },

  events: {
    'click .js-redo-search-checkbox-input': 'onRedoSearchCheckboxClicked',
    'click .js-redo-search-button': 'onRedoSearchButtonClicked',
  },

  initialize(options) {
    this.query = options.query;
    this.mapSearchData = options.mapSearchData;
    this.model = this.mapConfig = options.mapConfig;
    this.searchResults = options.searchResults;

    this.mapSearchData.on('change', _.bind(this.onMapSearchDataChanged, this));

    this.searchResults.on('change', _.bind(this.onSearchResultsChanged, this));

    StaticStickitView.prototype.initialize.call(this, options);

    this.initializeUpdateMapCheckbox();
    this.query.on('change:service_type', _.bind(this.initializeUpdateMapCheckbox, this));
  },

  initializeUpdateMapCheckbox() {
    const ticked = this.shouldRedoSearchWhenMapMoves();
    this.mapConfig.set('redoSearchWhenMapMoves', ticked);
  },

  shouldRedoSearchWhenMapMoves() {
    let should_redo = this.autoUpdateEnabled();
    const cookie = $.cookie('update_map_by_default');
    if (cookie !== undefined) {
      should_redo = cookie == 'true';
    }
    return should_redo;
  },

  autoUpdateEnabled() {
    return Rover.context.autoUpdateMapByServiceType[this.query.get('service_type')];
  },

  performSearch() {
    this.query.set(this.mapSearchData.toJSON());
  },

  showCheckbox() {
    this.$('.js-redo-search-button').addClass('hidden');
    this.$('.js-redo-search-checkbox').show();
  },

  showButton() {
    this.$('.js-redo-search-button').removeClass('hidden');
    this.$('.js-redo-search-checkbox').hide();
  },

  onSearchResultsChanged() {
    if (!this.mapSearchData.boundsSameAs(this.query.toJSON())) {
      this.initializeUpdateMapCheckbox();
      this.showCheckbox();
    }
  },

  onMapSearchDataChanged() {
    // Redo the search when the map moves
    if (this.mapConfig.get('redoSearchWhenMapMoves')) {
      this.performSearch();
    } else {
      this.showButton();
    }
  },

  onRedoSearchCheckboxClicked() {
    const isChecked = $('.js-redo-search-checkbox-input').is(':checked');
    $.cookie('update_map_by_default', isChecked.toString());
  },

  onRedoSearchButtonClicked() {
    dataLayer.push({ event: 'map-moved-redo-search' });
    this.performSearch();
    this.showCheckbox();
  },
});



// WEBPACK FOOTER //
// ./js/backbone/views/search/redo_search_in_map_view.js